module.exports = __webpack_public_path__ + "static/media/play-button.fda1b2c6.svg";